import React from 'react'
import PropTypes from 'prop-types'
import { StyledModal } from './component.styles'
import Summary from './Summary/component'
import AddProgramStartDate from 'components/ProgramStartDateModal/AddProgramStartDate'
import AddStatement from 'components/PurposeModal/AddStatement'
import AddGoals from 'components/GoalsModal/flag.on/AddGoals'
import AddImplementationApproach from 'components/ImplementationApproachModal/flag.on/AddImplementationApproach'
import ModalHeader from 'components/ModalHeader'
import ModalFooter from 'components/ModalFooter'

const SummaryModal = ({
  additionalGoalCount,
  currentStep,
  errors,
  goBack,
  handleChange,
  handleClose,
  handleNextButtonClick,
  handleStepChange,
  handleChangeGoalCount,
  hasApiError,
  isSubmitting,
  modals,
  preferences,
  setFieldValue,
  touched,
  values,
}) => {
  const currentModal = modals?.[currentStep] || {}
  const { helpCopy, nextLabel, flowLabel } = currentModal

  return (
    !!modals && (
      <StyledModal
        dataTestId="summary-modal"
        isModalOpen={true}
        modalClose={() => handleClose}
      >
        <ModalHeader
          flowLabel={flowLabel}
          handleClose={handleClose}
          handleGoBack={goBack}
          showBackButton={currentStep !== 0}
        />
        {currentStep === 0 && (
          <Summary
            handleStepChange={handleStepChange}
            preferences={preferences}
          />
        )}
        {currentStep === 1 && (
          <AddImplementationApproach
            errors={errors}
            handleChange={handleChange}
            handleStepChange={handleStepChange}
            modalData={modals?.[1]}
            touched={touched}
            values={values}
          />
        )}
        {currentStep === 2 && (
          <AddStatement
            errors={errors}
            handleChange={handleChange}
            handleStepChange={handleStepChange}
            modalData={modals?.[2]}
            touched={touched}
            values={values}
          />
        )}
        {currentStep === 3 && (
          <AddGoals
            additionalGoalCount={additionalGoalCount}
            errors={errors}
            handleChange={handleChange}
            handleChangeGoalCount={handleChangeGoalCount}
            handleStepChange={handleStepChange}
            modalData={modals?.[3]}
            setFieldValue={setFieldValue}
            touched={touched}
            values={values}
          />
        )}
        {currentStep === 4 && (
          <AddProgramStartDate
            errors={errors}
            handleChange={handleChange}
            handleStepChange={handleStepChange}
            modalData={modals?.[4]}
            touched={touched}
            values={values}
          />
        )}
        <ModalFooter
          handleNextButtonClick={handleNextButtonClick}
          hasApiError={hasApiError}
          helpCopy={helpCopy}
          isSubmitting={isSubmitting}
          isValid={true}
          modalName="summary"
          nextButtonText={nextLabel}
          showCancelButton={false}
        />
      </StyledModal>
    )
  )
}

SummaryModal.propTypes = {
  additionalGoalCount: PropTypes.number,
  currentStep: PropTypes.number,
  errors: PropTypes.object,
  flowLabel: PropTypes.string,
  goBack: PropTypes.func,
  handleChange: PropTypes.func,
  handleChangeGoalCount: PropTypes.func,
  handleClose: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  handleStepChange: PropTypes.func,
  hasApiError: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  modals: PropTypes.array,
  preferences: PropTypes.object,
  setFieldValue: PropTypes.func,
  touched: PropTypes.object,
  values: PropTypes.object,
}

export default SummaryModal
